import { render, staticRenderFns } from "./read-modal.vue?vue&type=template&id=67266055&scoped=true&lang=pug&"
import script from "./read-modal.vue?vue&type=script&lang=js&"
export * from "./read-modal.vue?vue&type=script&lang=js&"
import style0 from "./read-modal.vue?vue&type=style&index=0&id=67266055&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67266055",
  null
  
)

export default component.exports